import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManagePromotion() {
    const userRole = localStorage.getItem("role");
    const userCity = localStorage.getItem("city");
    const loggedUserID = localStorage.getItem("uid");
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editID, setEditID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ name: "", image: "" });


    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        {
            name: "Image",
            cell: (row) => (
                <img
                    src={row.image || 'placeholder-image-url'}
                    alt={row.name}
                    style={{maxWidth:"256px", maxHeight:"256px"}}
                />
            ),
        },
        { name: "Description", selector: (row) => row.content, wrap: true },
        {
            name: "Status",
            cell: (row) => (
                <button
                    className={`btn btn-${row.status ? "success" : "danger"}`}
                    onClick={() => toggleStatus(row._id, row.status)}
                >
                    {row.status ? "Active" : "Inactive"}
                </button>
            ),
        },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "rgb(133, 218, 79)",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row._id)}>
                        <i
                            className="fa-solid fa-trash-can text-danger"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const toggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = !currentStatus;
            await HomeService.updatePromotionStatus(id, { status: newStatus });
            toast.success("Status updated!");
            fetchAllData();
        } catch (error) {
            toast.error("Failed to update status.");
            console.error("Error updating status:", error);
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success("City ID Copied")
            })
            .catch((err) => console.error("Error copying text: ", err));
    };

    const fetchAllData = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getPromotion();
            const arr = res?.data
                .map((ele, ind) => ({
                    sln: ind + 1,
                    ...ele,
                    // name: ele.name,
                    // image: ele.image,
                    // id: ele._id,
                }));
            setAllData(arr)
            console.log("TEE96", arr);

            if (userCity) {
                setAllData(arr.filter(item => item.id === userCity));
            }

        } catch (error) {
            console.error("Error fetching allData:", error);
            toast.error("Failed to load allData!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ content: row.content, image: row.image });
        setEditID(row._id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Promotion?",
            text: "Are you sure you want to delete this Promotion?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deletePromotion(id);
                Swal.fire("Deleted!", "Promotion has been deleted.", "success");
                fetchAllData();
            } catch (error) {
                // Swal.fire("Error!", "Failed to delete Promotion.", "error");
            }
        }
    };

    const handleImageUpload = async (e) => {
        const data = new FormData();
        data.append("image", e.target.files[0]);
        try {
            const res = await HttpClientXml.fileUplode("image-upload", "POST", data);

            setEditData({ ...editData, image: res.image });
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { content: editData.content, image: editData.image };
            if (isEdit) {
                await HomeService.updatePromotion(editID, data);
                toast.success("Promotion updated successfully!");
            }
            setIsEdit(false);
            setEditData({ content: "", image: "" });
            fetchAllData();
        } catch (error) {
            // toast.error("Failed to save promotion.");
            console.error("Error saving promotion:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit Promotion</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                <div className="col-md-12 mt-3">
                                        <label htmlFor="inputGroupFile04">Image</label>
                                        {editData.image && (

                                            <div>
                                                <img
                                                    src={editData.image}
                                                    alt="Promotion"
                                                    style={{ maxWidth: "100%" }}
                                                />
                                            </div>

                                        )}
                                        <input
                                            type="file"
                                            id="inputGroupFile04"
                                            className="form-control"
                                            onChange={handleImageUpload}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="cityName">
                                            Description<span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            id="content"
                                            className="form-control"
                                            value={editData.content}
                                            onChange={(e) =>
                                                setEditData({ ...editData, content: e.target.value })
                                            }
                                            placeholder="Enter Description"
                                        />
                                    </div>

                                    


                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage Promotion
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={allData}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManagePromotion;
